<template>
  <div class="not-open-model">
    <div class="model-inner">
      <div class="title">
        海外航线在线值船请前往皇家加勒比APP<br/>或<br/><a href="https://www.royalcaribbean.com/booked">www.royalcaribbean.com</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckInIndex",
  created() {
    let href = window.location.href;
    if(href.indexOf('www.rclolci.com')>=0) {
      window.location.href = "https://www.rcclchina.com.cn/Rccl.Olci/Olci/CheckInIndex";
    }
  }
}
</script>

<style scoped lang="less">
.not-open-model {
  height: 700px;
  background-image: url("https://resource.rcclchina.com.cn/SC%E8%88%B9%E9%98%9F/SC%20Banner/SC-Banner-01.jpg");
  & .model-inner {
    position: relative;
    width: 1200px;
    height: 700px;
    margin: 0 auto;
    & .title {
      position: absolute;
      top: 35%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 700px;
      text-align: center;
      font-size: 30px;
      padding: 25px 50px;
      line-height: 1.5;
      font-weight: 500;
      color: #FFFFFF;
      background: linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));
      & > a {
        text-decoration: underline;
        color: #FFFFFF;
      }
    }
  }
}
</style>
